var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireAlarmCentralStation01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.52,13.31H2.48V2.28h11.03V13.31z M2.98,12.81h10.03V2.78H2.98V12.81z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.81,5.57h2.32v0.47H5.36v1.43h1.63v0.46H5.36v1.95H4.81V5.57z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.61,8.52L8.16,9.88H7.59l1.46-4.31h0.67l1.47,4.31H10.6l-0.46-1.36H8.61z M10.02,8.09L9.6,6.85 c-0.1-0.28-0.16-0.54-0.22-0.79H9.36C9.3,6.32,9.23,6.58,9.15,6.84L8.73,8.09H10.02z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireAlarmCentralStation01);
export default __webpack_public_path__ + "static/media/FireAlarmCentralStation-01.af9de1c97337e6ceb15299ed7cf8b71e.svg";
export { ForwardRef as ReactComponent };